const __uknown_error__dp = {
	structure: {
		type: 'Page',
		styleId: 'p2',
		id: '__uknown_error__dp',
		components: [
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-iuqkrar1',
				dataQuery: '#dataItem-iuqkrars',
				layout: {
					width: 752,
					height: 81,
					x: 203,
					y: 379,
					scale: 1.0,
					rotationInDegrees: 0.0,
					fixedPosition: false,
				},
				propertyQuery: 'propItem-iuqkrarv',
				componentType: 'wysiwyg.viewer.components.WRichText',
			},
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-iuqksom1',
				dataQuery: '#dataItem-iuqksoml',
				layout: {
					width: 475,
					height: 37,
					x: 207,
					y: 482,
					scale: 1.0,
					rotationInDegrees: 0.0,
					fixedPosition: false,
				},
				propertyQuery: 'propItem-iuqksoml1',
				componentType: 'wysiwyg.viewer.components.WRichText',
			},
			{
				type: 'Component',
				styleId: 'style-ivs5pjao',
				id: 'comp-iuqkv7ht',
				dataQuery: '#dataItem-iuqkv7ij',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
				layout: {
					width: 198,
					height: 56,
					x: 203,
					y: 561,
					scale: 1.0,
					rotationInDegrees: 0.0,
					fixedPosition: false,
				},
				propertyQuery: 'propItem-iuqkv7ik',
				componentType: 'wysiwyg.viewer.components.SiteButton',
			},
			{
				type: 'Component',
				styleId: 'wp2',
				id: 'comp-iuqlqwdz',
				dataQuery: '#dataItem-iuqlqwf7',
				layout: {
					width: 374,
					height: 264,
					x: 149,
					y: 107,
					scale: 1.0,
					rotationInDegrees: 0.0,
					fixedPosition: false,
				},
				propertyQuery: 'propItem-iuqlqwfc',
				componentType: 'wysiwyg.viewer.components.WPhoto',
			},
		],
		mobileComponents: [
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-iuqkrar1',
				dataQuery: '#dataItem-iuqkrars',
				layout: {
					width: 320,
					height: 78,
					x: 0,
					y: 202,
					scale: 0.8084127123905273,
					rotationInDegrees: 0.0,
					anchors: [
						{
							distance: 18,
							originalValue: 265,
							type: 'BOTTOM_TOP',
							locked: true,
							targetComponent: 'comp-iuqksom1',
						},
					],
					fixedPosition: false,
				},
				propertyQuery: 'mobile_propItem-iuqkrarv',
				componentType: 'wysiwyg.viewer.components.WRichText',
			},
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-iuqksom1',
				dataQuery: '#dataItem-iuqksoml',
				layout: {
					width: 277,
					height: 52,
					x: 21,
					y: 292,
					scale: 0.6948499742213815,
					rotationInDegrees: 0.0,
					anchors: [
						{
							distance: 29,
							originalValue: 372,
							type: 'BOTTOM_TOP',
							locked: true,
							targetComponent: 'comp-iuqkv7ht',
						},
					],
					fixedPosition: false,
				},
				propertyQuery: 'mobile_propItem-iuqksoml1',
				componentType: 'wysiwyg.viewer.components.WRichText',
			},
			{
				type: 'Component',
				styleId: 'style-ivs5pjao',
				id: 'comp-iuqkv7ht',
				dataQuery: '#dataItem-iuqkv7ij',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
				layout: {
					width: 204,
					height: 56,
					x: 53,
					y: 366,
					scale: 0.863837598531476,
					rotationInDegrees: 0.0,
					anchors: [
						{
							distance: 0,
							originalValue: 428,
							type: 'BOTTOM_PARENT',
							locked: true,
							targetComponent: '__404__dp',
						},
					],
					fixedPosition: false,
				},
				propertyQuery: 'propItem-iuqkv7ik',
				componentType: 'wysiwyg.viewer.components.SiteButton',
			},
			{
				type: 'Component',
				styleId: 'wp2',
				id: 'comp-iuqlqwdz',
				dataQuery: '#dataItem-iuqlqwf7',
				layout: {
					width: 272,
					height: 196,
					x: 24,
					y: -7,
					scale: 1.0,
					rotationInDegrees: 0.0,
					anchors: [
						{
							distance: 35,
							originalValue: 208,
							type: 'BOTTOM_TOP',
							locked: true,
							targetComponent: 'comp-iuqkrar1',
						},
					],
					fixedPosition: false,
				},
				propertyQuery: 'propItem-iuqlqwfc',
				componentType: 'wysiwyg.viewer.components.WPhoto',
			},
		],
		dataQuery: '#__uknown_error__dp',
		skin: 'wysiwyg.viewer.skins.page.TransparentPageSkin',
		layout: {
			width: 980,
			height: 637,
			x: 0,
			y: 0,
			scale: 1.0,
			rotationInDegrees: 0.0,
			fixedPosition: false,
		},
		componentType: 'mobile.core.components.Page',
	},
	data: {
		document_data: {
			__uknown_error__dp: {
				type: 'Page',
				id: '__uknown_error__dp',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				title: 'error',
				hideTitle: true,
				icon: '',
				descriptionSEO: '',
				metaKeywordsSEO: '',
				pageTitleSEO: '',
				pageUriSEO: 'error',
				hidePage: false,
				underConstruction: false,
				tpaApplicationId: 0,
				pageSecurity: {
					requireLogin: false,
				},
				isPopup: false,
				indexable: true,
				isLandingPage: true,
				pageBackgrounds: {
					desktop: {
						custom: true,
						ref: '#customBgImg3vn',
						isPreset: true,
					},
					mobile: {
						custom: true,
						ref: '#customBgImg24ta',
						isPreset: true,
					},
				},
				translationData: {
					uriSEOTranslated: false,
				},
				ignoreBottomBottomAnchors: true,
			},
			customBgImg24ta: {
				type: 'BackgroundMedia',
				id: 'customBgImg24ta',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				color: '#FFFFFF',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
			},
			customBgImg3vn: {
				type: 'BackgroundMedia',
				id: 'customBgImg3vn',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				color: '#FFFFFF',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
			},
			'dataItem-iuqkrars': {
				type: 'StyledText',
				id: 'dataItem-iuqkrars',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				text:
					'<h4 class="font_4" style="font-size:66px"><span style="color:#3EB8EA"><span style="font-size:66px"><span style="font-family:helvetica-w01-light,helvetica-w02-light,sans-serif">Awkward...</span></span></span></h4>',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
			},
			'dataItem-iuqksoml': {
				type: 'StyledText',
				id: 'dataItem-iuqksoml',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				text:
					'<p class="font_7" style="font-size:22px; line-height:1.7em"><span style="color:#184A56"><span style="font-family:helvetica-w01-light,helvetica-w02-light,sans-serif"><span style="font-size:22px">This page isn&rsquo;t available.</span></span></span></p>',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
			},
			'dataItem-iuqkv7ij': {
				type: 'LinkableButton',
				id: 'dataItem-iuqkv7ij',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				label: 'Go Home',
				link: '#dataItem-iwis0lzk',
			},
			'dataItem-iuqlqwf7': {
				type: 'Image',
				id: 'dataItem-iuqlqwf7',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				title: '',
				uri: '4167f5_355a3e17b02f4c58b61d1a2cfeca06d3~mv2.png',
				description: '',
				width: 400,
				height: 282,
				alt: '',
			},
			'dataItem-iwis0lzk': {
				type: 'ExternalLink',
				id: 'dataItem-iwis0lzk',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				url: './',
				target: '_self',
			},
		},
		design_data: {},
		behaviors_data: {},
		connections_data: {},
		theme_data: {
			'style-ivs5pjao': {
				type: 'TopLevelStyle',
				id: 'style-ivs5pjao',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				style: {
					properties: {
						'alpha-bg': '0',
						'alpha-bgh': '1',
						'alpha-brd': '1',
						'alpha-brdh': '0',
						'alpha-txt': '1',
						'alpha-txth': '1',
						bg: '#3EB8EA',
						bgh: '#4EB7F5',
						'boxShadowToggleOn-shd': 'false',
						brd: '#4EB7F5',
						brdh: '#3D9BE9',
						brw: '2',
						fnt: 'normal normal normal 22px/1.4em helvetica-w01-light',
						rd: '40px',
						shd: '0px 1px 4px 0px rgba(0,0,0,0.6)',
						txt: '#4EB7F5',
						txth: '#FFFFF1',
					},
					propertiesSource: {
						'alpha-bg': 'value',
						'alpha-brdh': 'value',
						bg: 'value',
						bgh: 'value',
						brd: 'value',
						brdh: 'value',
						brw: 'value',
						fnt: 'value',
						rd: 'value',
						shd: 'value',
						txt: 'value',
						txth: 'value',
					},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.SiteButton',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
			},
		},
		component_properties: {
			'mobile_propItem-iuqkrarv': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1.0,
				packed: true,
				overrideAlignment: 'center',
			},
			'mobile_propItem-iuqksoml1': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1.0,
				packed: true,
			},
			'propItem-iuqkrarv': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				brightness: 1.0,
				packed: true,
			},
			'propItem-iuqksoml1': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				brightness: 1.0,
				packed: true,
			},
			'propItem-iuqkv7ik': {
				type: 'ButtonProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				align: 'center',
				margin: 0,
			},
			'propItem-iuqlqwfc': {
				type: 'WPhotoProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				displayMode: 'fill',
				onClickBehavior: 'goToLink',
				effectName: 'none',
			},
		},
	},
	title: 'error',
	pageUriSEO: 'error',
}

export default __uknown_error__dp
